// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-plus.js';

import { paths } from '../generated/square-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-plus', Original, paths);
